'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/7/26.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _ErrorLabel = require('../ErrorLabel/ErrorLabel');

var _ErrorLabel2 = _interopRequireDefault(_ErrorLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupBuyingModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GroupBuyingModal, _Component);

  function GroupBuyingModal() {
    (0, _classCallCheck3.default)(this, GroupBuyingModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GroupBuyingModal).call(this));

    _this.state = {
      closeHover: false,
      error: ''
    };
    return _this;
  }

  (0, _createClass3.default)(GroupBuyingModal, [{
    key: 'onConfirmBtnClick',
    value: function onConfirmBtnClick(info) {
      var onItemClick = this.props.onItemClick;

      var number = this.refs.buyNumber && this.refs.buyNumber.value;
      if (onItemClick) {
        if (!isNaN(parseInt(number, 10))) {
          this.setState({
            error: ''
          });
          number = parseInt(number, 10);
          onItemClick((0, _extends3.default)({}, info, { number: number }));
        } else {
          this.setState({
            error: '请正确输入数量'
          });
        }
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./GroupBuyingModal.scss');
      var _props = this.props;
      var data = _props.data;
      var isOpened = _props.isOpened;
      var onClose = _props.onClose;
      var errorText = _props.errorText;
      var _state = this.state;
      var closeHover = _state.closeHover;
      var error = _state.error;

      var hoverClassName = styles.zhuan_a;
      if (closeHover) {
        hoverClassName = styles.zhuan;
      }
      var currentError = error + errorText;
      var customStyle = {
        content: {
          /*  position: 'absolute',
           top: '40px',
           left: '40px',
           bottom: '40px',
           right: '40px',
           border: '1px solid #ccc',
           background: '#fff',
           borderRadius: '4px',
           overflow: 'auto',
           outline: 'none',
           padding: '0px',
           zIndex: 10 */
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 10,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 0px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '80rem',
          maxWidth: '80rem'
        }
      };
      var contentDiv = '';
      var currentInfo = void 0;
      var planContent = void 0;
      if (data instanceof Array && data.length > 0) {
        currentInfo = data[0];
        if (data[0].content) {
          planContent = data[0].content.split('#');
        }
        contentDiv = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.groupPlan },
            _react2.default.createElement(
              'div',
              { className: styles.planTitle },
              data[0].groupPlanName
            ),
            _react2.default.createElement(
              'div',
              { className: styles.describe },
              data[0].describe
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.planContentUl },
              data[0].content ? planContent.map(function (content, index) {
                return _react2.default.createElement(
                  'li',
                  { key: index },
                  index + 1 + '.' + content
                );
              }) : ''
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.info },
            _react2.default.createElement(
              'div',
              { className: styles.item },
              '艺品总数：',
              data[0].totalNumber
            ),
            _react2.default.createElement(
              'div',
              { className: styles.item },
              '剩余数量：',
              data[0].currentNumber
            ),
            _react2.default.createElement(
              'div',
              { className: styles.item },
              '限购数量：',
              data[0].maxNumber
            ),
            _react2.default.createElement(
              'div',
              { className: styles.rightItem },
              '当前团购价格：',
              data[0].currentPrice
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.groupStatus },
            '团购状态：' + data[0].status
          ),
          _react2.default.createElement(
            'div',
            { className: styles.endLine },
            '截止日期：' + data[0].endDate
          ),
          _react2.default.createElement(
            'div',
            { className: styles.number },
            '购买数量：',
            _react2.default.createElement('input', { className: styles.inputNum, ref: 'buyNumber', type: 'text' })
          ),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.close },
          _react2.default.createElement('img', { className: hoverClassName, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return onClose();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement(
          'form',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.contentContainer },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                '团购'
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            contentDiv,
            _react2.default.createElement('div', { style: { width: '100%', height: 8 } })
          ),
          _react2.default.createElement(
            'div',
            { style: { width: '100%' } },
            _react2.default.createElement(_SubmitBtn2.default, {
              style: { margin: '10px auto 0', width: 175, fontSize: 16, letterSpacing: 8, height: 30, lineHeight: '30px', float: 'none' },
              btnClick: function btnClick() {
                return _this2.onConfirmBtnClick(currentInfo);
              },
              text: '立即参与' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.bottomContainer },
            _react2.default.createElement(_ErrorLabel2.default, { error: currentError || '' })
          )
        )
      );
    }
  }]);
  return GroupBuyingModal;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array,
  onItemClick: _react.PropTypes.func,
  errorText: _react.PropTypes.string,
  isOpened: _react.PropTypes.bool,
  onClose: _react.PropTypes.func
}, _temp);
exports.default = GroupBuyingModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GroupBuyingModal/GroupBuyingModal.js
 ** module id = 1350
 ** module chunks = 0
 **/